import React, { useEffect, useState } from 'react';
import { Card, Collapse, List } from 'antd';
import { TableSecProps } from './props';

import { RowLine, SpanBlock } from './styles';
import { maskCurrency, maskUnd } from '../../../../../../utils/mask';
import { EntregaNoCdServices } from '../../services/entregaNoCdServices';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../../store';
import { Sorter, sorterParamsHandle } from '../../../../../../utils/sorte';

const CardSecMobile: React.FC<TableSecProps> = ({ ordemEntrega, cddAtivo }) => {
  const { Panel } = Collapse;
  const [control, setControl] = useState(false);
  const { inscricaoAtiva } = useSelector((state: ApplicationState) => state.auth);
  const [loadingSec, setLoadingSec] = useState(false);
  const [response, setResponse] = useState();

  useEffect(() => {
    if (control === false) {
      setLoadingSec(true);
      // try {
      //   setLoadingSec(true);
      //   EntregaNoCdServices.getPedidosOrdemCarga(
      //     ordemEntrega,
      //     cddAtivo,
      //     inscricaoAtiva,
      //     sorterParamsHandle(Sorter)
      //   ).then((res) => {
      //     setResponse(res?.data.pedidos);
      //     if (res?.data.pedidos) setLoadingSec(false);
      //   });
      // } finally {
      //   setControl(true);
      // }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [control, loadingSec, ordemEntrega]);

  return (
    <Collapse key={ordemEntrega}>
      <Panel header="Detalhes" key={ordemEntrega}>
        <>
          <List
            dataSource={response}
            loading={loadingSec}
            renderItem={(item: any) => (
              <List.Item>
                <Card>
                  <RowLine>
                    <p>
                      <strong>N° da NF</strong> <SpanBlock>{item.numNota}</SpanBlock>
                    </p>
                  </RowLine>
                  <RowLine>
                    <p>
                      <strong>Fornecedor</strong> <SpanBlock>{item.fornecedor}</SpanBlock>
                    </p>
                  </RowLine>
                  <RowLine>
                    <p>
                      <strong>Cidade origem</strong> <SpanBlock>{item.cidadeOrigem}</SpanBlock>
                    </p>
                  </RowLine>
                  <RowLine>
                    <p>
                      <strong>Destinatário</strong> <SpanBlock>{item.destinatario}</SpanBlock>
                    </p>
                  </RowLine>
                  <RowLine>
                    <p>
                      <strong>Peso Bruto</strong>{' '}
                      <SpanBlock>{maskUnd(item.pesoBruto) + ' KG'}</SpanBlock>
                    </p>
                  </RowLine>
                  <RowLine>
                    <p>
                      <strong>Valor da mercadoria</strong>{' '}
                      <SpanBlock>{maskCurrency(item.valor)}</SpanBlock>
                    </p>
                  </RowLine>

                  <RowLine>
                    <p>
                      <strong>Carga</strong> <SpanBlock>{item.carga}</SpanBlock>
                    </p>
                  </RowLine>
                  <RowLine>
                    <p>
                      <strong>Análise fiscal</strong> <SpanBlock>{item.analisefiscal}</SpanBlock>
                    </p>
                  </RowLine>
                </Card>
              </List.Item>
            )}
          />
        </>
      </Panel>
    </Collapse>
  );
};

export default CardSecMobile;
